"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        display: flex;\n        flex: ", ";\n        min-width: ", "px;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        display: flex;\n        flex: 1;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        &&& {\n            display: flex;\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _createStyled["default"].div(_templateObject()),
    ContentWrapper = _createStyled["default"].div(_templateObject2()),
    Label = _createStyled["default"].label(_templateObject3()),
    FieldWrapper = _createStyled["default"].div(_templateObject4(), function (_ref) {
  var length = _ref.length;
  return length;
}, function (_ref2) {
  var fontSize = _ref2.fontSize,
      length = _ref2.length,
      paddingLeft = _ref2.paddingLeft,
      paddingRight = _ref2.paddingRight;
  return (0, _pixelToNumber["default"])(fontSize) * length + // eslint-disable-line indent
  (0, _pixelToNumber["default"])(paddingLeft) + (0, _pixelToNumber["default"])(paddingRight);
}),
    Border = _createStyled["default"].hr(_templateObject5()),
    Field = _createStyled["default"].input(_templateObject6()),
    ARROW_RIGHT_KEY = 39,
    ARROW_LEFT_KEY = 37,
    BACKSPACE_KEY = 8;

var SeparatedInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(SeparatedInput, _Component);

  function SeparatedInput(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SeparatedInput);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeparatedInput).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focusedCellIndex: null,
      hover: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCellWidth", function (length) {
      var _this$props$theme = _this.props.theme,
          fontSize = _this$props$theme.fontSize,
          paddingLeft = _this$props$theme.paddingLeft,
          paddingRight = _this$props$theme.paddingRight;
      return "".concat((0, _pixelToNumber["default"])(fontSize) * length + (0, _pixelToNumber["default"])(paddingLeft) + (0, _pixelToNumber["default"])(paddingRight), "px");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCellStyle", function (baseStyle, length) {
      return _objectSpread({}, baseStyle, {
        minWidth: _this.getCellWidth(length)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCells", function () {
      var _this$props = _this.props,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value,
          mask = _this$props.mask,
          separator = _this$props.separator;
      var copyOfValue = value;
      return mask.split(separator).map(function (chunk, i) {
        var cellValue = copyOfValue.substring(0, chunk.length);
        copyOfValue = copyOfValue.substring(chunk.length);
        return {
          value: cellValue,
          index: i,
          maxLength: chunk.length,
          isFilled: cellValue.length === chunk.length,
          placeholder: chunk,
          domRef: _this.domRefs[i]
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRootHover", function () {
      _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRootBlur", function () {
      _this.setState({
        hover: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedCell", function (domCell) {
      return _this.getCells().find(function (_ref3) {
        var domRef = _ref3.domRef;
        return domCell === domRef.current;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCarriageAbsolutePosition", function (selectedCell, carriagePositionInCell) {
      var cells = _this.getCells();

      var absolutePosition = 0;

      for (var i = 0; i < selectedCell.index; i++) {
        absolutePosition += cells[i].maxLength;
      }

      absolutePosition += carriagePositionInCell;
      return absolutePosition;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeCellForFocus", function (carriageAbsolutePosition) {
      var focusPreviousCellIfLeftLimitIsReached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var focusNextCellIfRightLimitIsReached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var cells = _this.getCells();

      var carriagePosition = carriageAbsolutePosition,
          cellIndex = 0,
          cellForFocus = cells[cellIndex];

      while (cellIndex < cells.length - 1 && carriagePosition >= cellForFocus.maxLength) {
        cellIndex += 1;
        carriagePosition -= cellForFocus.maxLength;
        cellForFocus = cells[cellIndex];
      }

      if (focusPreviousCellIfLeftLimitIsReached && carriagePosition === 0 && cellForFocus.index > 0) {
        // if current cell is empty and we want jump to previous cell
        cellForFocus = cells[cellForFocus.index - 1];
        carriagePosition = cellForFocus.maxLength;
      } else if (focusNextCellIfRightLimitIsReached && carriagePosition === cellForFocus.maxLength && cellForFocus.index < cells.length - 1) {
        // if current cell is full and we want jump to next cell
        cellForFocus = cells[cellForFocus.index + 1];
        carriagePosition = 0;
      }

      cellForFocus.domRef.current.focus();
      cellForFocus.domRef.current.setSelectionRange(carriagePosition, carriagePosition);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleCellChange", function (nextCellValue, carriagePosition, domCell) {
      var onChange = _this.props.onChange,
          cells = _this.getCells(),
          selectedCell = _this.getSelectedCell(domCell),
          carriageAbsolutePosition = _this.getCarriageAbsolutePosition(selectedCell, carriagePosition),
          maxValueLength = cells.reduce(function (acc, curr) {
        return acc + curr.maxLength;
      }, 0),
          prevValue = cells.map(function (_ref4) {
        var value = _ref4.value;
        return value;
      }).join(''),
          nextValue = cells.map(function (_ref5) {
        var value = _ref5.value,
            index = _ref5.index;
        return index === selectedCell.index ? nextCellValue : value;
      }).join('');

      if (nextValue !== prevValue && nextValue.length <= maxValueLength) {
        onChange({
          target: {
            value: nextValue
          }
        }, function () {
          _this.computeCellForFocus(carriageAbsolutePosition, false, nextValue.length >= prevValue.length // if we add value
          );
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (event) {
      var domCell = event.target,
          keyCode = event.keyCode,
          carriagePositionStart = domCell.selectionStart,
          carriagePositionEnd = domCell.selectionEnd,
          cells = _this.getCells(),
          selectedCell = _this.getSelectedCell(domCell);

      if (keyCode === BACKSPACE_KEY) {
        var prevCell = cells[selectedCell.index - 1];

        if (prevCell && carriagePositionStart === 0 && carriagePositionEnd - carriagePositionStart === 0) {
          var value = prevCell.value,
              maxLength = prevCell.maxLength,
              domRef = prevCell.domRef;

          _this.handleCellChange(value.substring(0, value.length - 1), maxLength - 1, domRef.current);

          event.preventDefault();
        }
      } else if (keyCode === ARROW_LEFT_KEY) {
        if (carriagePositionStart === 0) {
          var carriageAbsolutePosition = _this.getCarriageAbsolutePosition(selectedCell, carriagePositionStart);

          _this.computeCellForFocus(carriageAbsolutePosition, true, false);

          event.preventDefault();
        }
      } else if (keyCode === ARROW_RIGHT_KEY) {
        if (carriagePositionStart === selectedCell.value.length) {
          var _carriageAbsolutePosition = _this.getCarriageAbsolutePosition(selectedCell, carriagePositionStart);

          _this.computeCellForFocus(_carriageAbsolutePosition, false, true);

          event.preventDefault();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (event) {
      var domCell = event.target,
          nextCellValue = domCell.value,
          carriagePosition = domCell.selectionStart;

      _this.handleCellChange(nextCellValue, carriagePosition, domCell);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFocus", function (event) {
      var onFocus = _this.props.onFocus,
          domCell = event.target,
          carriagePosition = domCell.selectionStart,
          cells = _this.getCells(),
          currentValue = cells.map(function (_ref6) {
        var value = _ref6.value;
        return value;
      }).join(''),
          selectedCell = _this.getSelectedCell(domCell),
          carriageAbsolutePosition = _this.getCarriageAbsolutePosition(selectedCell, carriagePosition);

      if (carriageAbsolutePosition > currentValue.length) {
        _this.computeCellForFocus(currentValue.length, false, true);
      } else {
        _this.setState({
          focusedCellIndex: selectedCell.index
        });

        onFocus(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focusedCellIndex: null
      });

      onBlur(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePaste", function (event) {
      var _nextValue;

      var domCell = event.target,
          clipboardData = event.clipboardData,
          selectionStart = domCell.selectionStart,
          selectionEnd = domCell.selectionEnd,
          cells = _this.getCells(),
          selectionLength = selectionEnd - selectionStart,
          selectedCell = _this.getSelectedCell(domCell),
          maxValueLength = cells.reduce(function (acc, curr) {
        return acc + curr.maxLength;
      }, 0),
          prevValue = cells.map(function (_ref7) {
        var value = _ref7.value;
        return value;
      }).join(''),
          pastedValue = clipboardData.getData('Text').substring(0, maxValueLength - prevValue.length + selectionLength);

      var nextValue = selectedCell.value;
      nextValue = nextValue.split('');

      (_nextValue = nextValue).splice.apply(_nextValue, [selectionStart, selectionLength].concat((0, _toConsumableArray2["default"])(pastedValue.split(''))));

      nextValue = nextValue.join('');

      _this.handleCellChange(nextValue, selectionStart + pastedValue.length, domCell);

      event.preventDefault();
    });
    var _mask = props.mask,
        _separator = props.separator;
    _this.domRefs = _mask.split(_separator).map(function () {
      return _react["default"].createRef();
    });
    return _this;
  }

  (0, _createClass2["default"])(SeparatedInput, [{
    key: "compileStyled",
    value: function compileStyled(styleSheet) {
      if (typeof styleSheet === 'function') {
        return styleSheet.call(this, _objectSpread({}, this.props.theme || {}), this.props, this.state || {});
      } else {
        return {};
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var styles = this.compileStyled(_index["default"]),
          _this$props2 = this.props,
          label = _this$props2.label,
          input = _this$props2.input,
          error = _this$props2.error,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          focusedCellIndex = this.state.focusedCellIndex,
          cells = this.getCells(),
          computedProps = {
        disabled: disabled,
        type: input,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onPaste: this.handlePaste
      };
      return _react["default"].createElement(Root, {
        className: className,
        styles: _objectSpread({}, styles.root, {
          flexDirection: 'column'
        })
      }, label && _react["default"].createElement(Label, {
        styles: styles.label
      }, label), _react["default"].createElement(ContentWrapper, {
        onMouseEnter: this.handleRootHover,
        onMouseLeave: this.handleRootBlur,
        styles: styles.contentWrapper
      }, cells.map(function (_ref8, index) {
        var value = _ref8.value,
            placeholder = _ref8.placeholder,
            domRef = _ref8.domRef,
            maxLength = _ref8.maxLength;
        return _react["default"].createElement(FieldWrapper, {
          key: String(value + index),
          styles: _this2.getCellStyle(styles.wrapper, maxLength),
          length: maxLength
        }, _react["default"].createElement(Field, (0, _extends2["default"])({}, computedProps, {
          value: value,
          placeholder: placeholder,
          ref: domRef,
          styles: !error && focusedCellIndex === index ? styles.fieldFocused : styles.field
        })), _react["default"].createElement(Border, {
          styles: styles.border
        }), _react["default"].createElement(Border, {
          styles: !error && focusedCellIndex === index ? styles.activeBorderFocused : styles.activeBorder
        }));
      })));
    }
  }]);
  return SeparatedInput;
}(_react.Component);

exports["default"] = SeparatedInput;
(0, _defineProperty2["default"])(SeparatedInput, "displayName", 'SeparatedInput');
(0, _defineProperty2["default"])(SeparatedInput, "propTypes", {
  input: _propTypes["default"].string.isRequired,
  error: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  cellFormat: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  value: _propTypes["default"].string,
  mask: _propTypes["default"].string.isRequired,
  separator: _propTypes["default"].string.isRequired,
  theme: _propTypes["default"].object,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(SeparatedInput, "defaultProps", {
  maxLength: 1,
  // hack for width style
  label: '',
  value: '',
  disabled: false,
  onChange: function onChange() {
    return {};
  },
  onBlur: function onBlur() {
    return {};
  },
  onFocus: function onFocus() {
    return {};
  }
});